import { Navigate, RouteObject, useRoutes } from "react-router-dom";
import Login from "../views/Login";
import Home from "../views/Home";
import ConsultationRecord from "../views/ConsultationRecord";
import ConsultationDetails from "../views/ConsultationDetails";
import Dashboard from "../views/Dashboard";

const routers: RouteObject[] = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/home",
    element: <Home />,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: "/home/consultation-record",
        element: <ConsultationRecord />,
      },
      {
        path: "/home/consultation-details/:userId/:state",
        element: <ConsultationDetails />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/login" replace />,
  },
];

const RouterView = () => {
  const elem = useRoutes(routers);
  return elem;
};

export { routers, RouterView };
